import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { BUILDING_TYPE } from '@buildium/angularjs-core/dist/constants/properties';

const actions = {
    addAssociation: {
        method: 'POST',
        url: `${BASE_PATH_API}/associations`
    },
    getAssociation: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId`
    },
    updateAssociation: {
        method: 'PUT',
        url: `${BASE_PATH_API}/associations/:associationId`
    },
    getBankAccountOptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/bankAccountOptions`,
        isArray: true
    },
    saveTaxPayerInfo: {
        method: 'POST',
        url: `${BASE_PATH_API}/associations/:buildingId/taxPayer`
    },
    deleteTaxPayerInfo: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/associations/:buildingId/taxPayer`
    },
    isSubscriberWithinMaximumNumberOfUnitsAllowed: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/:propertyId/isWithinMaxNumberOfUnitsAllowed`
    },
    doesPropertyContainRecurringNonLeaseTransaction: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:id/recurringExpenses`
    },
    reactivateAssociation: {
        method: 'PUT',
        url: `${BASE_PATH_API}/associations/:id/reactivate`
    },
    inactivateAssociation: {
        method: 'PUT',
        url: `${BASE_PATH_API}/associations/:id/inactivate`
    },
    deleteAssociation: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/associations/:associationId`
    },
    saveAssociationOwnerWebsiteSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/settings/:associationId/resident`
    },
    getAssociationOwnerWebsiteSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/:associationId/resident`,
        isArray: true
    },
    getAssociationOwnerWebsiteSettingOverrides: {
        method: 'GET',
        url: `${BASE_PATH_API}/settings/resident/overrides`,
        isArray: true,
        params: {
            'buildingType': BUILDING_TYPE.HOA
        },
    },
    getViolationSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/violationSettings/:associationId`,
    },
    saveViolationSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/violationSettings/:associationId`
    },
    saveViolationFineSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/violationSettings/:associationId/fines`
    },
    getAllViolationSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/violationSettings`,
        isArray: true
    },
    getUnitList: {
        method: 'GET',
        url: `${BASE_PATH_API}/association/:associationId/unitsList`,
        isArray: true
    },
    getOwnershipAccountsByUnit: {
        method: 'GET',
        url: `${BASE_PATH_API}/association/:associationId/units/:unitId/ownershipAccounts`,
        isArray: true
    },
    getUnit: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/units/:unitId`
    },
    updateUnit: {
        method: 'PUT',
        url: `${BASE_PATH_API}/associations/units/:unitId`
    },
    deleteUnit: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/associations/units/:unitId`
    },
    getBoardMembers: {
        method: 'GET',
        url: `${BASE_PATH_API}/associationBuildings/:propertyId/boardMembers`
    },
    getAssociations: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations`,
        params: {
            '$count': true
        },
        isArray: true
    },
    getAssociationsForAssociationOwner: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/options`,
    },
    getPreferredVendors: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/preferredVendors`
    },
    getAssociationUnits: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/units`,
        params: {
            '$count': true
        }
    },
    getMailingLayouts: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/mailingLayouts`
    },
    getMailingSenders: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/mailingSenders`
    },
    getLockedPeriod: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/lockedPeriod/:associationId`
    },
    hasDelinquentAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/delinquent`
    },
    getDefaultManagementFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/managementFeePolicy`
    },
    doesPropertyHaveAnyCalendars: {
        method: 'GET',
        url: `${BASE_PATH_API}/v1/associations/:associationId/calendars/anyCalendarsExist`
    }
};

export function AssociationsApi(
    $httpParamSerializer
) {
    const service =  createActions(actions);
    service.getAssociationsExportUrl = function getAssociationsExportUrl(params) {
        return `${BASE_PATH_API}/associations/export?${$httpParamSerializer(params)}`;
    };

    service.exportAssociationUnitsUrl = function getAssociationUnitsExportUrl(associationId, params) {
        return `${BASE_PATH_API}/associations/${associationId}/units/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
AssociationsApi.$inject = [
    '$httpParamSerializer'
];
